import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getOrganizations, getOrganizationScopes, switchOrganization } from 'app/api/OrgAPI'
import { setAccessToken } from '@driftt/web-auth'
import { A, H4, P, Icon } from '@driftt/tide-core-legacy'
import { sortByName, getAuthorizationType } from './utils'
import ACCESS from 'utils/Access'
import { min } from 'ramda'
import { orgId as getOrgId } from 'app/modules/org/selectors'
import './styles.css'

const MIN_LENGTH = 5
const INCREMENT_LENGTH = 10

const onSwitch = async (orgId, authClientId) => {
  switchOrganization(orgId, authClientId)
    .then(({ accessToken, expiresAt }) => {
      setAccessToken({ token: accessToken, expirationInSeconds: expiresAt })
      window.location.replace('/')
    })
    .catch((err) => console.error(err))
}

const applyScopes = (scopes, organizatons) => (
  organizatons.map(organization => {
    return {
      ...organization,
      'scopes': scopes[organization.id]
    }
  })
)

const OrgSwitcher = ({ organization: { name, scopes, id }, authClientId }) => (
  <div className="organization-info-container" onClick={() => onSwitch(id, authClientId)}>
    <div>
      <Icon className="organization-logo" name='drift-logo-round' height='40' />
    </div>
    <div>
      <H4 className="organization-global-name"> {name} </H4>
      <P className="organization-access-right"> {getAuthorizationType(scopes)} </P>
    </div>
  </div>
)

class Organizations extends Component {
  state = {
    organizations: [],
    maxLength: MIN_LENGTH
  }

  async componentDidMount() {
    if (ACCESS.isMultiOrg()) {
      try {
        const [
          organizations,
          scopes,
        ] = await Promise.all([
          getOrganizations(),
          getOrganizationScopes()
        ])

        this.setState({ organizations: applyScopes(scopes, sortByName(organizations)) })
      } catch (e) {
        console.error(e)
      }
    }
  }

  getMaxLength = () => {
    const { organizations, maxLength } = this.state
    return min(organizations.length, maxLength)
  }

  incrementMaxLength = () => {
    this.setState({ maxLength: this.state.maxLength + INCREMENT_LENGTH })
  }

  decrementMaxLength = () => {
    this.setState({ maxLength: this.state.maxLength - INCREMENT_LENGTH })
  }

  canShowMore = () => {
    const { organizations, maxLength } = this.state
    return organizations.length - maxLength > 0
  }

  canShowLess = () => {
    const { maxLength } = this.state
    return maxLength > MIN_LENGTH
  }

  render() {
    const { organizations } = this.state
    const { orgId, authClientId } = this.props



    return (
      <div className="org-switcher">
        <H4 className="org-switcher-header"> ORGANIZATIONS </H4>
        {organizations.slice(0, this.getMaxLength()).map((organization) => (
          orgId !== organization.id && <OrgSwitcher organization={organization} authClientId={authClientId} />
        ))}
        {this.canShowMore() && <A className="org-switcher-increment" href="#" onClick={this.incrementMaxLength}> Show more </A>}
        {this.canShowLess() && <A className="org-switcher-increment" href="#" onClick={this.decrementMaxLength}> Show less </A>}
        <A className="org-switcher-increment" href="#Q8ZtAkVfwr4abMm"> Add an organization... </A>
      </div>
    )
  }
}



const mapStateToProps = state => {
  return {
    orgId: getOrgId(state)
  }
}

export default connect(mapStateToProps)(Organizations)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/AppSwitcher/Organizations/index.js